import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    is: false
};
export const isReportJournal = createSlice({
    initialState,
    name: 'journal',
    reducers: {
        showAJournalReport: state => {
            state.is = true;
        },
        hideJournalReport: state => {
            state.is = false;
        }
    }
});
export default isReportJournal.reducer;
